export default "__VITE_ASSET__C63LKd7E__"